/** @format */

import { SURVEY } from "../constants/constants";
export const QUESTION_TYPES = [
  {
    label: "Multiple Choice",
    value: SURVEY.QUESTION__TYPES.MULTIPLE__CHOICE,
  },
  {
    label: "Short Answer",
    value: SURVEY.QUESTION__TYPES.SHORT_ANSWER,
  },
];
export const answer = () => [{ option: "" }];

export const getQuestion = (questionType) => {
  switch (questionType) {
    case SURVEY.QUESTION__TYPES.MULTIPLE__CHOICE:
      return {
        type: SURVEY.QUESTION__TYPES.MULTIPLE__CHOICE,
        name: "",
        optionRequestDTOS: answer(),
        isRequired: false,
      };
    case SURVEY.QUESTION__TYPES.SHORT_ANSWER:
      return {
        type: SURVEY.QUESTION__TYPES.SHORT_ANSWER,
        name: "",
        optionRequestDTOS: [],
        isRequired: false,
      };
    default:
      return {
        type: SURVEY.QUESTION__TYPES.MULTIPLE__CHOICE,
        name: "",
        optionRequestDTOS: answer(),
        isRequired: false,
      };
  }
};

export const isSurveyInvalid = (surveyQuestions) =>
  surveyQuestions.some(
    (question) =>
      question.name.trim() === "" ||
      (question.type === SURVEY.QUESTION__TYPES.MULTIPLE__CHOICE &&
        question.optionRequestDTOS.some((option) => option.option.trim() === ""))
  );
